module.exports = __webpack_public_path__ + "static/media/maxresdefault.f27ab17d.jpg";